import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const NextEpisodeContainer = styled.div<React.CSSProperties>`
  bottom: ${172 * Screen.widthRatio}px;
  display: flex;
  right: ${445 * Screen.widthRatio}px;
  position: absolute;
  z-index: 10;
`;

export default withAnimation(NextEpisodeContainer);
